import { Marker } from './constants';

export class PixelsWriter {
  constructor(storage, size) {
    this.size = size;
    this.storage = storage;
    this.col = 0;
    this.row = 0;
  }

  onSixel = (sixel, sixelColor) => {
    const intialRow = this.row;
    let _sixel = sixel | 0;

    while (_sixel != 0) {
      this.row++;

      const isOn = _sixel % 2 === 1;
      _sixel = (_sixel / 2) | 0;

      if (!isOn) {
        continue;
      }

      const firstPixelColorComponentIndex = (this.row * this.size.width + this.col) * 4;

      this.storage[firstPixelColorComponentIndex + 0] = sixelColor.r;
      this.storage[firstPixelColorComponentIndex + 1] = sixelColor.g;
      this.storage[firstPixelColorComponentIndex + 2] = sixelColor.b;
      this.storage[firstPixelColorComponentIndex + 3] = 255;
    }

    this.col++;
    this.row = intialRow;
  };

  onCaretMove = caretMovement => {
    if (caretMovement === Marker.CR) {
      this.col = 0;
    }

    if (caretMovement === Marker.LF) {
      this.row += 6;
      this.col = 0;
    }
  };
}
